import { useEffect } from 'react';

import { enableGA } from 'client/redux/user';
import { useAppDispatch, useAppSelector } from 'client/hooks';
import { selectLang } from 'client/redux/settings/selectors';

import { useTranslation } from './translation';

// @ts-expect-error Appcues is provided to window by added script tag in the index.html
const _window: typeof globalThis & { CookieConsent: any } = globalThis || {};

export const useCookieConsent = () => {
  const appDispatch = useAppDispatch();
  const { translate } = useTranslation();
  const lang = useAppSelector(selectLang);

  useEffect(() => {
    document.documentElement.classList.add('cc--darkmode');

    _window.CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: 'cloud',
          position: 'bottom left',
          equalWeightButtons: true,
          flipButtons: false,
        },
        preferencesModal: {
          layout: 'box',
          position: 'right',
          equalWeightButtons: true,
          flipButtons: false,
        },
      },
      categories: {
        necessary: {
          readOnly: true,
        },
        analytics: {},
        marketing: {},
      },
      language: {
        default: lang,
        translations: {
          [`${lang}`]: {
            consentModal: {
              title: translate('cookieConsent.consentModal.title'),
              description: translate('cookieConsent.consentModal.description'),
              acceptAllBtn: translate('cookieConsent.consentModal.acceptAllBtn'),
              acceptNecessaryBtn: translate('cookieConsent.consentModal.acceptNecessaryBtn'),
              showPreferencesBtn: translate('cookieConsent.consentModal.showPreferencesBtn'),
              footer: translate('cookieConsent.consentModal.footer'),
            },
            preferencesModal: {
              title: translate('cookieConsent.preferencesModal.title'),
              acceptAllBtn: translate('cookieConsent.preferencesModal.acceptAllBtn'),
              acceptNecessaryBtn: translate('cookieConsent.preferencesModal.acceptNecessaryBtn'),
              savePreferencesBtn: translate('cookieConsent.preferencesModal.savePreferencesBtn'),
              closeIconLabel: translate('cookieConsent.preferencesModal.closeIconLabel'),
              serviceCounterLabel: translate('cookieConsent.preferencesModal.serviceCounterLabel'),
              sections: [
                {
                  title: translate('cookieConsent.preferencesModal.sections[0].title'),
                  description: translate('cookieConsent.preferencesModal.sections[0].description'),
                },
                {
                  title: translate('cookieConsent.preferencesModal.sections[1].title'),
                  description: translate('cookieConsent.preferencesModal.sections[1].description'),
                  linkedCategory: 'necessary',
                },
                {
                  title: translate('cookieConsent.preferencesModal.sections[2].title'),
                  description: translate('cookieConsent.preferencesModal.sections[2].description'),
                  linkedCategory: 'analytics',
                },
                {
                  title: translate('cookieConsent.preferencesModal.sections[3].title'),
                  description: translate('cookieConsent.preferencesModal.sections[3].description'),
                  linkedCategory: 'marketing',
                },
              ],
            },
          },
        },
      },
      disablePageInteraction: true,
      onConsent: function () {
        if (_window.CookieConsent.acceptedCategory('analytics')) {
          // Analytics category enabled

          appDispatch(enableGA(true));
        }
      },
    });
  }, [lang]);

  return null;
};
